import { EipError } from '@wolffun/shared/src/types';
import { THETAN_COIN_CONTRACT_ADDRESS, THETAN_GEM_CONTRACT_ADDRESS } from '@wolffun/shared/constants';
import { CurrencyType, systemCurrencyToBlockchainNumber } from '@wolffun/system-currency';
import claimTokenContract from '@wolffun/shared/src/contracts/claimTokenSmartContract';
import depositSmartContract from '@wolffun/shared/src/contracts/depositSmartContract';
import { getGasPrice } from '@wolffun/shared/src/utils/ethereum.util';
export const deposit = async props => {
  const getAddress = type => {
    switch (type) {
      case CurrencyType.THC:
        return THETAN_COIN_CONTRACT_ADDRESS;

      case CurrencyType.THG:
        return THETAN_GEM_CONTRACT_ADDRESS;

      default:
        throw 'Currency address is not supported';
    }
  };

  try {
    const gasPrice = await getGasPrice();
    const {
      senderAddress,
      amount
    } = props;
    const toAddress = getAddress(amount.token);
    const data = await (await depositSmartContract.getContract()).methods.deposit(toAddress, systemCurrencyToBlockchainNumber(amount)).send({
      from: senderAddress,
      gasPrice
    });
    return {
      error: EipError.NO_ERROR,
      data: String(data === null || data === void 0 ? void 0 : data.transactionHash)
    };
  } catch (err) {
    if (err.code) {
      return {
        error: err.code
      };
    } else {
      return {
        error: EipError.UNNKOWN
      };
    }
  }
};
export const claimToken = async ({
  amount,
  expiredAt,
  id,
  signature,
  tokenAddress,
  accountAddress
}) => {
  try {
    const gasPrice = await getGasPrice();
    const data = await (await claimTokenContract.getContract()).methods.claimToken(tokenAddress, id, amount, expiredAt, signature).send({
      from: accountAddress,
      gasPrice
    });
    return {
      error: EipError.NO_ERROR,
      data: String(data === null || data === void 0 ? void 0 : data.transactionHash)
    };
  } catch (err) {
    if (err.code) {
      return {
        error: err.code
      };
    } else {
      return {
        error: EipError.UNNKOWN
      };
    }
  }
};
export { getBalance, getThetaBalance, personalSign, ensureProvider, getAccounts, switchToBSC } from '@wolffun/shared/src/utils/ethereum';